import type ApolloClient from 'apollo-client'

const REFRESH_DELAY_MS = 2000

/**
 * Schedules a delayed refetch of the specified Apollo queries.
 *
 * Uses internal Apollo Client queryManager API to find and refetch active
 * observable queries by name. This is necessary because Apollo 2.x doesn't
 * provide a public API to refetch queries by name outside of a mutation's
 * refetchQueries option.
 */
export function scheduleDelayedRefetch(client: ApolloClient<any>, queries: string[]): void {
  if (!queries?.length) {
    return
  }

  setTimeout(() => {
    const queryManager = (client as any).queryManager
    if (!queryManager?.queries) {
      return
    }
    queryManager.queries.forEach(
      ({ observableQuery }: { observableQuery?: { queryName: string; refetch: () => Promise<any> } }) => {
        if (!observableQuery) {
          return
        }

        const queryName = observableQuery.queryName
        if (queries.includes(queryName)) {
          observableQuery.refetch().catch((err: unknown) => {
            console.warn('[scheduleDelayedRefetch] refetch failed for query "%s":', queryName, err)
          })
        }
      }
    )
  }, REFRESH_DELAY_MS)
}
